import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/AuthLayout';
import Register from './pages/Register';
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyEmail from "./pages/VerifyEmail";
import SetPassword from "./pages/SetPassword";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import ChangePassword from "./pages/ChangePassword";
import DeleteAccount from "./pages/DeleteAccount";
import TurnstileTest from "./pages/TurnstileTest";
import './App.css'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/auth/login" replace />} />
      <Route path="/login" element={<Navigate to="/auth/login" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/test-turnstile" element={<TurnstileTest />} />
      <Route element={<AuthLayout />}>
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/verify-email" element={<VerifyEmail />} />
        <Route path="/auth/set-password" element={<SetPassword />} />
        <Route path="/auth/change-password" element={<ChangePassword />} />
        <Route path="/auth/delete-account" element={<DeleteAccount />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
